/**
 * better-nav-dropdown.js
 * Click-to-open controller for the compact (non-mega) nav dropdowns.
 * Mirrors mega-nav-shop.js: open state is the trigger's aria-expanded, toggled
 * on click. Outside-click and Escape close. No hover.
 *
 * Self-contained custom element; does not extend Horizon's Component base.
 */
class NavDropdown extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('[data-dd-toggle]');
    if (!this.toggleBtn) return;
    this.isOpen = false;

    this.toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    this._onDocClick = (e) => {
      if (this.isOpen && !this.contains(e.target)) this.close();
    };
    this._onKey = (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.toggleBtn.focus();
      }
    };
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKey);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKey);
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    // Close any sibling dropdowns/megas first so only one is open at a time.
    document.querySelectorAll('nav-dropdown, mega-nav-shop').forEach((el) => {
      if (el !== this && typeof el.close === 'function') el.close();
    });
    this.isOpen = true;
    this.toggleBtn.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.isOpen = false;
    this.toggleBtn.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('nav-dropdown')) {
  customElements.define('nav-dropdown', NavDropdown);
}
